import { render, staticRenderFns } from "./userCancellations.vue?vue&type=template&id=ed90d280&scoped=true&lang=html&"
import script from "./userCancellations.vue?vue&type=script&lang=js&"
export * from "./userCancellations.vue?vue&type=script&lang=js&"
import style0 from "./userCancellations.vue?vue&type=style&index=0&id=ed90d280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90d280",
  null
  
)

export default component.exports